//creating job details model

exelare_jobs.define('jobDetailModel',['noconflict','knockout'], function ($, ko) {
    return function (item, schema, appModel) {
        var self = this;
        var sourceItem = item;

        //mapping field names to ko.observable
        for (var f in schema) {
            if (item[f])
            {
                self[f] = ko.observable(item[f]);
            }
            else {
                self[f] = ko.observable("");
            }
        }

        var city, state;

        if (item["Location"]) {
            var logParts = item["Location"].split(",");
            if (logParts.length > 1) {
                city = logParts[0].trim();
                state = logParts[1].trim();
            } else {
                state = logParts[0].trim();
            }
        }
        
        self.address = ko.computed(function () {
            return item["Address1"];
        });

        self.city = ko.computed(function () {
            return item["City"]?item["City"]:city;
        });

        self.state = ko.computed(function () {
            return item["State"]?item["State"]:state;
        });

        self.zipCode = ko.computed(function () {
            return item["ZipCode"];
        });

        self.primarySkills = ko.computed(function () {
            return item["PrimarySkills"];
        });

        self.totalExp = ko.computed(function () {
            return item["TotalExp"];
        });

        self.education = ko.computed(function () {
            return item["Education"];
        });

        self.industry = ko.computed(function () {
            return item["Industry"];
        });

        self.minSalary = ko.computed(function () {
            return item["MinSalary"];
        });

        self.applyUrl = ko.computed(function () {
            return ExelareSettings.applicationFormTemplate;
        });

        self.descriptionUrl = ko.observable(ExelareSettings.serviceUrl + "desc/?cid=" + ExelareSettings.curCompanyId + "&userId=" + ExelareSettings.curUserId + "&reqIntId=" + item["ReqIntID"]);

        self.htmlDescription = ko.computed(function () {
        	//remove leading space and <br>
        	var rg = /^([\s\t\r]*(<br\s*\/?>\s*)*)+/ig;
        	var desc = (self.Description ? self.Description() : '');
        	var leadRmv = /<[\/]?html>|<[\/]?head>|<[\/]?body\b[^>]*>|<meta\b[^>]*>/ig;
        	
        	desc = desc.replace(leadRmv, "").replace(/\n/g, '<br>').replace(rg, "");
	        return desc;
        });

        self.nohtmlDescription = ko.computed(function () {
            return $("<div>" + self.htmlDescription() + "</div>").text();
        });

        self.PostDate = ko.computed(function () {
            return (new Date(self.CreateDate())).toLocaleDateString();
        });

        self.PostDateISO = ko.computed(function () {
            return (new Date(self.CreateDate())).toISOString();
        });

        self.EndDate = ko.computed(function () {
            if ("EndDate" in item && item["EndDate"]) {
                try {
                    return (new Date(item["EndDate"])).toISOString();
                } catch(err)
                {

                }
            }

            return (new Date()).addDays(1).toISOString();
        });

        self.viewJobUrlCmd = ko.computed(function () {
            if (window.location.href.indexOf("viewJob") < 0) {
                if (window.location.search) {
                    return window.location.href + (window.location.href.indexOf("?") >= 0 ? "&" : "?") + "viewJob=" + encodeURI(self.ReqID());
                } else {
                    return window.location.href + (window.location.href.indexOf("#") >= 0 ? "&" : "#") + "viewJob=" + encodeURI(self.ReqID());
                }
            }
            return window.location.href
        })

        self.ApplyLinkedInMeta = ko.computed(function () {
            return "companyID:"+ExelareSettings.curCompanyId+";submitType:2";
        })

        self.RecruiterCompanyName = ko.computed(function () {
            return ExelareSettings.companyName;
        })
        
        self.isShareJob = ko.computed(function () {
            return $.deparam.fragment().viewJob!=null;
        })

        self.viewJob = function () {
            var detailsModal = $('#detailsModal');

            ko.cleanNode(detailsModal[0]);
            ko.applyBindings(self, detailsModal[0]);

            detailsModal.modal('show');
        };

        self.applyJob = function () {
            $('#detailsModal').modal('hide');
            $('#appFormModal').modal('show');

            appModel.applyJobTitle(self.JobTitle());
            appModel.applyJobReqID(self.ReqID());
        };
    };
});


